import {ISelection, Selection} from '@fluentui/react'

const onlineOrderSelection: ISelection = new Selection()

export {onlineOrderSelection}